export enum RideDelayStatusEnum {
  NO_SHOW = "NO_SHOW",
  DELAYED = "DELAYED",
  MAYBE_LATE = "MAYBE_LATE",
  EARLY = "EARLY",
  ON_TIME = "ON_TIME",
  FUTURE = "FUTURE",
  PAST = "PAST",
  NOT_TRACKED = "NOT_TRACKED",
}

/** Visible live-map group header order: Late → Maybe late → Early → OK → Future → Past → Not tracked → No Show. */
export const sortedRideDelayStatus: RideDelayStatusEnum[] = [
  RideDelayStatusEnum.DELAYED,
  RideDelayStatusEnum.MAYBE_LATE,
  RideDelayStatusEnum.EARLY,
  RideDelayStatusEnum.ON_TIME,
  RideDelayStatusEnum.FUTURE,
  RideDelayStatusEnum.PAST,
  RideDelayStatusEnum.NOT_TRACKED,
  RideDelayStatusEnum.NO_SHOW,
];
